module.exports = __webpack_public_path__ + "img/pgd_a_11101.08bb41b9.png";